import { router, Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function BankAccountLayout() {
  const { theme } = useStyles();

  return (
    <Stack
      screenOptions={{
        contentStyle: {
          backgroundColor: theme.colors.background_1,
        },
      }}
    >
      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="index"
          options={{
            headerTitle: 'Bank Account',
            headerLeft: () => null,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="tutorial/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="tutorial/index"
          options={{
            headerTitle: 'Bank Account',
            headerLeft: () => null,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="connect/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="connect/index"
          options={{
            headerTitle: 'Bank Account',
            headerLeft: () => null,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="verify/index"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="verify/index"
          options={{
            headerTitle: 'Bank Account',
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }

                  router.navigate('/partner/more/bank-account');
                }}
              />
            ),
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          }}
        />
      )}
    </Stack>
  );
}
